import { useEffect, useState } from "react";
import { useCourtyard } from "@/context/CourtyardContext";
import { scrollToId } from "@/lib/event";

function useNow() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  return now;
}

export default function Countdown() {
  const { event: ev } = useCourtyard();
  const now = useNow();
  if (!ev.start_iso) return null;
  const start = new Date(ev.start_iso).getTime();
  const end = ev.end_iso ? new Date(ev.end_iso).getTime() : start + 12 * 3600 * 1000;

  if (now >= end) {
    return (
      <div className="mt-8 rounded-2xl border border-[rgba(181,148,82,.45)] bg-[var(--ivory-2)] p-4" data-testid="countdown-after">
        <p className="font-display text-xl text-[var(--emerald)]">Diye bujh gaye, yaadein nahi.</p>
        <button type="button" onClick={() => scrollToId("memories")} className="mt-2 text-sm font-semibold underline underline-offset-4">See the memories from the courtyard</button>
      </div>
    );
  }
  if (now >= start) {
    return (
      <p className="mt-8 font-display text-xl italic text-[var(--emerald)]" data-testid="countdown-live">
        The courtyard is lit. Come on in. Aur haan, photos daalna mat bhoolna.
      </p>
    );
  }
  let s = Math.floor((start - now) / 1000);
  const parts = [
    ["din", Math.floor(s / 86400)],
    ["ghante", Math.floor((s %= 86400) / 3600)],
    ["minute", Math.floor((s %= 3600) / 60)],
    ["second", s % 60],
  ];
  return (
    <div className="mt-9" data-testid="countdown">
      <p className="eyebrow">Diye jalne mein</p>
      <div className="mt-2 flex gap-5" role="timer" aria-live="off">
        {parts.map(([label, n]) => (
          <div key={label} className="text-center">
            <span className="font-display block text-3xl font-semibold tabular-nums text-[var(--emerald)]">{String(n).padStart(2, "0")}</span>
            <span className="text-xs text-[#3d5a51]">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
